import { State } from "./types";
import { Boundaries } from "@planzone/core";

function handleListEdition(
  state: State,
  list: Boundaries["editList"]["success"],
): State {
  return state.map((res) => {
    const index = res.projects.findIndex((p) => list.uuid === p.rootList.uuid);

    return index !== -1
      ? {
          ...res,
          projects: [
            ...res.projects.slice(0, index),
            {
              ...res.projects[index],
              rootList: { ...res.projects[index].rootList, ...list },
            },
            ...res.projects.slice(index + 1),
          ],
        }
      : res;
  });
}

export { handleListEdition };
